import PrivacyPolicyPage from './PrivacyPolicyPage';
import PrivacyPolicyPageNuttall from '../../../customized/alan-nuttall-flexeserve-eu/components/PrivacyPolicyPage/PrivacyPolicyPage';
import { ToggleComponent } from '../../../featureToggle';

export default ToggleComponent(PrivacyPolicyPage, {
  styledComponentsVariants: {
    'alan-nuttall-flexeserve-eu': PrivacyPolicyPageNuttall,
  },
});
